// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import { PublicClientApplication, EventType } from '@azure/msal-browser';

// import { msalConfig } from './authConfig.js';
// import App from './App';

// // import "bootstrap/dist/css/bootstrap.min.css";
// import './index.css';
// import msalInstance from './authServiceInstance.js';

// /**
//  * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
//  * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
//  */
// // const msalInstance = new PublicClientApplication(msalConfig);
// // Default to using the first account if no account is active on page load
// if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//   // Account selection logic is app dependent. Adjust as needed for different use cases.
//   msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
// }

// // Optional - This will update account state if a user signs in from another tab or window
// msalInstance.enableAccountStorageEvents();

// // Listen for sign-in event and set active account
// msalInstance.addEventCallback((event) => {
//   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//     const account = event.payload.account;
//     const accountDetail = JSON.stringify(account);
//     localStorage.setItem('userDetail', accountDetail);
//     // localStorage.setItem("accessToken", event.payload.accessToken);
//     msalInstance.setActiveAccount(account);
//   }
// });
// const root = ReactDOM.createRoot(document.getElementById('root'));
// // Initialize MSAL instance
// await msalInstance.initialize(); // Explicit initialization if required

// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App instance={msalInstance} />
//     </BrowserRouter>
//   </React.StrictMode>
// );

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { EventType } from '@azure/msal-browser';
// import msalInstance from "./authServiceInstance";
import './index.css';
import App from './App';
import msalInstance from './auth/authServiceInstance';

const root = ReactDOM.createRoot(document.getElementById('root'));

(async () => {
  // ✅ Initialize MSAL once
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  // ✅ Restore active account
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
    // localStorage.setItem("userDetail", JSON.stringify(accounts[0]));
  }

  // ✅ Listen for future logins
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload.account);
      // localStorage.setItem(
      //   "userDetail",
      //   JSON.stringify(event.payload.account)
      // );
    }
  });

  // ✅ Render app
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App instance={msalInstance} />
      </BrowserRouter>
    </React.StrictMode>
  );
})();
